module.exports = __webpack_public_path__ + "static/img/t56.884eb55e.png";